export const TABLE_FETCH   = 'TABLE_FETCH';
export const TABLE_UPDATE  = 'TABLE_UPDATE';
export const TABLE_SEARCH  = 'TABLE_SEARCH';
